export default "__VITE_ASSET__6sEFC1Ud__"